module.exports = __webpack_public_path__ + "media/images/countryrect/gm-f19fe2d69ae6afa4e3e5efe81494cf65.svg";